<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-12 offset-lg-1 col-lg-10 text-center">
                    <h5>
                        {{ $t('returnTokens.yourTokensWillReturn', { date: returnDate }) }}
                    </h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  computed: {
    returnDate () {
      let returnDate = this.$store.getters.getReturnTokensDate

      if (returnDate !== null) {
        returnDate = returnDate.toLocaleDateString()
      } else {
        returnDate = ''
      }

      return returnDate
    }
  }
}
</script>

<style scoped>
.card {
  color: white;
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border-radius: 20px;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
}
</style>
